<template >
<!-- <v-flex> -->
<v-card-text class="pa-0" >
    <v-select v-if="(content.type===`Enumerate`)" 
      :items="content.options"  
      :label="content.label"
      :value="value"
      :suffix="content.dim"
      menu-props="auto" 
      hide-details 
      v-bind:name="content.name"
      @input="updateValue"
      :disabled="content.disabled"      
      v-bind="$attrs" 
      :height="outlined?'15':'30'"
      :class="outlined?'body-1 px-2':''">
    </v-select>
    <v-checkbox v-else-if="(content.type===`Checkbox`)"
      :disabled="content.disabled"
      v-bind:name="content.name"
      @change="updateValue"
      v-bind="$attrs"     
      :label="outlined?'':content.label"
      :input-value="value"
      hide-details
      :class="outlined?'body-1 px-4':'mt-2'"
      color="primary">  
          
    </v-checkbox>
     <v-radio-group v-else-if="(content.type===`Radio`)" 
     v-model="radioGroup" >
      <v-radio v-for="(option, index) in content.options"
        :key="`lab` + index"
        :label="option.text"
        :value="n"
        :readonly="option.disabled" 
        v-bind="$attrs" 
        @input="$emit('input', $event.target.checked)"
      ></v-radio>
    </v-radio-group>
    <!-- <v-card-title  v-else-if="(content.type===`Title`)" 
     primary-title class="headline">
     {{content.label}}
    </v-card-title > -->
  
    <v-card color="primary" class="pa-1 ma-0 my-2 elevation-7" v-else-if="(content.type===`Title`)" >
      <v-toolbar height="30" dense class="primary--text">
    <v-toolbar-title class="subheading" >{{content.label}}</v-toolbar-title>
     </v-toolbar>
    </v-card>
 
    <v-text-field v-else
      :type="content.type" 
      :disabled="content.disabled" 
      v-bind="$attrs" 
      v-bind:name="content.name" 
      :value="content.type=='Status'? getStatusValue:value" 
      :suffix="content.dim"
      :label="outlined?'':content.label"
      :rules="[getmyRules]"
      :hide-details = true
      @input="updateValue"
      :height="outlined?'15':'28'"
      :class="outlined?'body-1 px-2':''"
           
    ></v-text-field>


</v-card-text  >
<!-- </v-flex> -->

  <!-- <td v-bind:colspan="COLSPAN">
    <label v-if="content.label">{{content.label}}</label>
    <input type="text" v-bind:name="content.name" :value="value" @input="$emit('input', $event.target.value)" :style="getInputStyle" v-if="(content.type===`String`)" :disabled="content.disabled" v-on:keyup.enter="onEnter" v-bind="$attrs" v-on="listeners">
    <select v-bind:name="content.name" v-bind:style="getInputStyle" v-if="(content.type===`Enumerate`)" :value="value" @input="$emit('input', $event.target.value)" :disabled="content.disabled" v-bind="$attrs" v-on="listeners">
      <option v-for="(option, index) in content.options" v-bind:value="option.value" :disabled="option.disabled" :key="`opt` + index">
        {{option.title}}
      </option>
    </select>
    <div v-if="(content.type===`Radio`)" style="display: inline">
      <label v-for="(option, index) in content.options" STYLE="padding-left: 5px;" :key="`lab` + index">
        <input type="radio" v-bind:name="content.name" :checked="value" @input="$emit('input', $event.target.checked)" :disabled="option.disabled" v-bind="$attrs" v-on="listeners">
        <DIV style="display:inline;">{{option.text}}</DIV>
      </label>
    </div>
    <input type="text" v-if="(content.type===`Status`)" class="statusParamClass" :style="getInputStyle" Readonly v-model="getStatusValue" v-bind="$attrs" v-on="listeners"/>
    <input type="password" v-bind:name="content.name" :value="value" @input="$emit('input', $event.target.value)" :style="getInputStyle" v-if="(content.type===`Password`)" :disabled="content.disabled" v-on:keyup.enter="onEnter" v-bind="$attrs" v-on="listeners"/>
    <input type="checkbox" v-if="(content.type===`Checkbox`)" :disabled="content.disabled" :checked="value" @input="$emit('input', $event.target.checked)" v-bind="$attrs" />
    <input type="number" :value="value" @input="$emit('input', $event.target.value)" v-bind:name="content.name" v-bind:style="getInputStyle" v-if="(content.type===`Digital`)" :disabled="content.disabled" v-bind="$attrs" v-on="listeners" :step="content.step" :min="content.min" :max="content.max" v-on:keyup.enter="onEnter"/>
  </td> -->
</template>
<script>

/*  :v-modal="value2" v-bind="$attrs"    @input="$emit('input', $event.target.value)"
  Leidžiami tipai:
  Digital = 0,     ///< \@D - skaitmeninis parametras
  Enumerate,       ///< \@E - Isvardijamasis parametras
  String,          ///< Eilutės tipas
  Checkbox,        ///< Checkbox
  Radio,           ///< Radio grupe bus sukurta
  Info,            ///< Tekstas (be ivedimo)
  Button,          ///< Mygtukas komandos vykdymui
  Custom,          ///< Vartotojo nuožiūra sukurtas nestandartinis parametras


*/
export default {
  name: 'itemParam',
  inheritAttrs: false,
  props: {
    content: {
      type: Object,
      required: true
    },
    COLSPAN: {
      type: Number
    },
    onEnter: {
      type: Function,
      required: false
    },
    grpId: {
      type: Number
    },
    value: {},
    outlined: false,
    inputStyle: {
      type: Object,
      required: false
    },

  },
  data () {
    return {
    }
  },
  methods: {
    updateValue: function(value) {      
      this.$emit('input', value)
    },
    getmyRules:function(v)
    {
      if (this.$props.content.regex) 
      {
        if(!RegExp(this.$props.content.regex).test(v))
          return "Invalid value"
        else 
          return true
      }
      else if(this.$props.content.max)
      {
        if(this.$props.content.type===`Number`)
        {
          if(this.$props.content.max > v)
            return true
          else 
            return "Invalid value"
        }
      }
      else if(this.$props.content.min)
      {
        if(this.$props.content.type===`Number`)
        {
          if(this.$props.content.min < v)
            return true
          else 
            return "Invalid value"
        }
      }
      else 
        return true
    }
  },
  computed: {
    getStatusValue: function () {
      return this.$store.getters.getStatusParamValue(this.$props.grpId, this.$props.content.name)
    }
  }
}
</script>

